import { Table } from '@tanstack/react-table';
import { Button } from '@repo/ui';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@repo/ui';
import FileDownloadIcon from '@repo/ui/components/icons/file/FileDownloadIcon';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { createRoot } from 'react-dom/client';
import { addPatient } from '../../types/patient.types';

interface PatientExportButtonProps {
    table: Table<addPatient>;
}

export default function PatientExportButton({ table }: PatientExportButtonProps) {
    const exportToPDF = () => {
        const doc = new jsPDF();
        const tableData = table.getRowModel().rows.map((row) => {
            return table
                .getAllColumns()
                .filter((column) => column.id !== 'actions')
                .map((column) => {
                    const value = row.getValue(column.id);
                    if (column.id === 'name') {
                        return `${row.original.first_name || ''} ${row.original.last_name || ''}`.trim();
                    } else if (column.id === 'is_black_list') {
                        return value === 1 ? 'محظور' : 'جديد';
                    }
                    return String(value) || '';
                });
        });

        const tableHeaders = table
            .getAllColumns()
            .filter((column) => column.id !== 'actions')
            .map((column) => {
                const header = column.columnDef.header;
                if (typeof header === 'function') {
                    const tempDiv = document.createElement('div');
                    const root = createRoot(tempDiv);
                    const headerElement = header({ column } as any) as React.ReactElement;
                    root.render(headerElement);
                    const textContent = tempDiv.textContent || column.id;
                    root.unmount();
                    return textContent;
                }
                return header?.toString() || column.id;
            });

        autoTable(doc, {
            head: [tableHeaders],
            body: tableData,
            styles: { font: 'Amiri', fontSize: 10, halign: 'center' },
            headStyles: { fillColor: [0, 102, 204] },
        });

        doc.save('patients.pdf');
    };

    const exportToExcel = () => {
        const tableData = table.getRowModel().rows.map((row) => {
            return table
                .getAllColumns()
                .filter((column) => column.id !== 'actions')
                .map((column) => {
                    const value = row.getValue(column.id);
                    if (column.id === 'name') {
                        return `${row.original.first_name || ''} ${row.original.last_name || ''}`.trim();
                    } else if (column.id === 'is_black_list') {
                        return value === 1 ? 'محظور' : 'جديد';
                    }
                    return String(value) || '';
                });
        });

        const tableHeaders = table
            .getAllColumns()
            .filter((column) => column.id !== 'actions')
            .map((column) => {
                const header = column.columnDef.header;
                if (typeof header === 'function') {
                    const tempDiv = document.createElement('div');
                    const root = createRoot(tempDiv);
                    const headerElement = header({ column } as any) as React.ReactElement;
                    root.render(headerElement);
                    const textContent = tempDiv.textContent || column.id;
                    root.unmount();
                    return textContent;
                }
                return header?.toString() || column.id;
            });

        const worksheetData = [tableHeaders, ...tableData];
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Patients');
        XLSX.writeFile(workbook, 'patients.xlsx');
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="outline"
                    className="flex items-center gap-2 bg-primery-blue-50 text-primery-blue-500 hover:text-primery-blue-500 hover:bg-primery-blue-100 border border-primery-blue-50 shadow-[0px_1px_2px_0px_#1018280D] rounded-lg px-[14px] py-2"
                >
                    <FileDownloadIcon />
                    <p className="text-xs tracking-normal font-normal leading-[22.49px]">
                        تصدير
                    </p>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="min-w-[120px]">
                <DropdownMenuItem onClick={exportToPDF}>
                    PDF
                </DropdownMenuItem>
                <DropdownMenuItem onClick={exportToExcel}>
                    Excel
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

